<div class="row" [ngClass]="columnLayout ? 'gy-3' : null">
  @if (attachmentsWithPreview?.length || attachmentsWithoutPreview?.length || attachmentsFetching) {
    <div [ngClass]="columnLayout ? 'col-12' : 'col'">
      @if (attachmentsWithPreview?.length || attachmentsWithoutPreview?.length) {
        @if (attachmentsWithPreview?.length) {
          <div class="row mt-1">
            @for (attachment of attachmentsWithPreview; track getAttachmentId(attachment); let i = $index) {
              <div class="col-auto text-center">
                <div class="attachment-preview mx-auto clickable border d-flex" [title]="attachment.file_name"
                    [style.background-size]="attachment.preview.height > PREVIEW_DISPLAY_HEIGHT || attachment.preview.width > PREVIEW_DISPLAY_WIDTH ? 'contain' : undefined"
                    [ngStyle]="{'background-image': 'url(\'' + attachment.preview.link.url + '\')', 'height': PREVIEW_DISPLAY_HEIGHT + 'px', 'width': PREVIEW_DISPLAY_WIDTH + 'px'}"
                    (click)="openWithLightbox(attachment, i)">
                  @if (getAttachmentId(attachment) === attachmentClickData?.attachmentId) {
                    <fa-icon class="mx-auto my-auto" icon="spinner" [appShowFaSpinner]="true" [fixedWidth]="true"/>
                  }
                </div>
                <div>
                  <ng-template [ngTemplateOutlet]="attachmentFilename" [ngTemplateOutletContext]="{attachment: attachment, lightbox: i, maxWidth: PREVIEW_DISPLAY_WIDTH}"/>
                </div>
              </div>
            }
          </div>
        }
        @if (attachmentsWithoutPreview?.length) {
          <div class="row mt-1">
            @for (attachment of attachmentsWithoutPreview; track getAttachmentId(attachment)) {
              <div class="col-auto">
                <fa-layers size="2x">
                  <fa-icon class="text-primary clickable" [icon]="['fas', attachment.mime_type | fontawesomeMime]"
                           [transform]="{x: -2}" (click)="openUrl(attachment)"/>
                  @if (getAttachmentId(attachment) === attachmentClickData?.attachmentId) {
                    <fa-icon icon="spinner"
                             [appShowFaSpinner]="true" [transform]="{size: 8, x: -2}"/>
                  }
                </fa-layers>
                <div class="d-inline-block">
                  <ng-template [ngTemplateOutlet]="attachmentFilename" [ngTemplateOutletContext]="{attachment: attachment, maxWidth: PREVIEW_DISPLAY_WIDTH}"/>
                </div>
              </div>
            }
          </div>
        }
      } @else {
        <app-ace-loading class="d-inline-block mb-5 w-100"/>
      }
    </div>
  }
  @if (addAllowed) {
    <div [ngClass]="columnLayout ? 'col-12' : 'col-md-3 col-sm-4'">
      <!-- Set ngfFixOrientation to false as it is true by default and breaks things. I am guessing this happens because the angular-file library uses
       Canvas to rotate the image. However, in modern browsers Canvas automatically rotates the image based on the Orientation in the file. So the library
       end ups producing a over-rotated image and loses Orientation meta-data which stops the browsers displaying the image correctly. -->
      <div ngfDrop accept="*" class="h-100 p-1 d-flex border" style="border-style: dashed !important;"  tabindex="0"
           [fileDropDisabled]="disabled"
           [ngfFixOrientation]="false"
           [ngClass]="{'border-success': dropValid, 'border-info': !dropValid && !!pasteImage?.focused}"
           [(validDrag)]="dropValid"
           (filesChange)="onFilesChange($event)"
           (paste)="onPaste($event)"
           (focus)="setPasteImageFocused(true)"
           (blur)="setPasteImageFocused(false)">
        <div class="my-auto w-100 text-center">
          <small>{{'Drag and drop files here or' | messageTranslate}}</small>
          <br>
          <input #fileSelect ngfSelect accept="*" multiple type="file" class="hide-file-input" [ngfFixOrientation]="false"
                 [disabled]="disabled"
                 (filesChange)="onFilesChange($event)">
          <button type="button" class="btn btn-secondary btn-sm" style="line-height: 1;"
                  [disabled]="disabled" (click)="fileSelect.click()"
                  (focus)="setPasteImageFocused(true)" (blur)="setPasteImageFocused(false)">
            {{'Choose files' | messageTranslate}}
          </button>
          @if (showPasteImageMsg && pasteImage?.show) {
            <br>
            <small>{{(pasteImage?.focused ? 'Paste an image or' : 'Click here to then Paste an image or') | messageTranslate}}</small>
          }
        </div>
      </div>
    </div>
  }
</div>

<app-upload-state [recordId]="recordId"
                  [autoAssociate]="autoAssociate"
                  [showCancel]="true"
                  [disabled]="disabled"
                  (attachmentUploading)="onAttachmentUploading($event)"
                  (attachmentAssociated)="onAttachmentAssociated($event)"/>

<ng-template #attachmentFilename let-attachment="attachment" let-lightbox="lightbox" let-maxWidth="maxWidth">
  <div class="d-inline-flex">
    <small [style.max-width.px]="maxWidth" [title]="attachment.file_name"
           class="text-body-secondary d-inline-block text-truncate clickable align-top"
           (click)="lightbox >= 0 ? openWithLightbox(attachment, lightbox) : openUrl(attachment)">
      {{attachment.file_name}}
    </small>
    &nbsp;
    <a (click)="openUrl(attachment)" [title]="'Download' | messageTranslate"><small class="align-top text-body-secondary clickable"><fa-icon icon="download" [fixedWidth]="true"/></small></a>
    <a class="user-select-none" [title]="'Copy link to clipboard' | messageTranslate" (click)="onCopyLink(attachment)" ><small class="align-top text-body-secondary clickable"><fa-icon icon="link" [fixedWidth]="true"/></small></a>
    @if (canDeleteAttachment(attachment)) {
      <a (click)="onDeleteAttachment(attachment)" [title]="'Delete' | messageTranslate"><small class="align-top text-body-secondary clickable"><fa-icon icon="times" [fixedWidth]="true"/></small></a>
    }
  </div>
</ng-template>
